

















































































































import Vue from "vue";
import InformationCard from "@/features/information/components/information-card.vue";
import { MedecinDocument } from "../../../models/MedecinDocument";
import { utils } from "@/util";
export default Vue.extend({
  data() {
    return {
      maladieVisible: true,
      vaccinsVisible: true,
      allergieVisible: true
    };
  },
  props: {
    medecin: {
      type: MedecinDocument || undefined,
    },
    maladies: {
      type: Array,
      default: () => []
    },
    allergies: {
      type: Array,
      default: () => []
    },
    vaccins: {
      type: Array,
      default: () => []
    },
    informationIndividu: {
      type: Array,
      default: () => []
    }
  },
  components: {
    InformationCard
  },
  filters: {
    inverseDate: (datenaissance: string) => {
      if (!datenaissance) return "";
      let d = utils.getDateFromString(datenaissance, "YYYY-MM-DD");
      return d.format("DD-MM-YYYY");
    }
  }
});
